import React from 'react';
import { motion } from 'framer-motion';

const FeatureCard = ({ icon: Icon, title, description, delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true, margin: "-100px" }}
      className="glass-card p-6 hover:shadow-lg transition-all duration-300 group"
      whileHover={{ 
        y: -5,
        boxShadow: '0 0 20px rgba(20, 187, 255, 0.3)'
      }}
    >
      <div className="inline-flex items-center justify-center p-3 bg-primary-500/10 rounded-lg text-primary-500 mb-4 group-hover:bg-primary-500/20 transition-colors duration-300">
        <Icon size={24} className="drop-shadow-[0_0_8px_rgba(20,187,255,0.7)]" />
      </div>
      <h3 className="text-xl font-semibold mb-2 text-white group-hover:text-primary-500 transition-colors duration-300">{title}</h3>
      <p className="text-gray-400 group-hover:text-gray-300 transition-colors duration-300">{description}</p>
    </motion.div>
  );
};

export default FeatureCard;
